import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Lezzet Yolda Kullanım Koşulları
          </h1>
          <p className="text-gray-500 text-sm mb-8">
            Son Güncelleme Tarihi: {LEGAL_CONFIG.lastUpdated}
          </p>

          {/* 1 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Taraflar ve Tanımlar</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              İşbu Kullanım Koşulları (&quot;Koşullar&quot;),{' '}
              <strong>{LEGAL_CONFIG.companyName}</strong> (&quot;Platform&quot; veya
              &quot;Biz&quot;) ile platformumuzu, mobil uygulamamızı veya web sitemizi kullanan
              kullanıcılar (&quot;Kullanıcı&quot; veya &quot;Siz&quot;) arasında geçerli
              olacaktır. Platformu kullanmaya başladığınızda işbu koşulları kabul etmiş
              sayılırsınız.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>
                <strong>Platform:</strong> Lezzet Yolda yemek siparişi ve teslimat hizmeti sunan
                dijital aracı platform.
              </li>
              <li>
                <strong>Restoran (Satıcı):</strong> Platform üzerinden sipariş alan ve yemek
                hazırlayan üye işyeri.
              </li>
              <li>
                <strong>Kurye:</strong> Siparişleri müşteriye teslim eden hizmet sağlayıcı.
              </li>
              <li>
                <strong>Sipariş:</strong> Kullanıcının restorandan talep ettiği ürün/hizmet.
              </li>
              <li>
                <strong>Aracı Hizmet Sağlayıcı:</strong> {LEGAL_CONFIG.companyName} — satış
                sözleşmesinin tarafı olmayıp yalnızca platformun kullanımını ve ödeme altyapısını
                sağlar.
              </li>
            </ul>
          </section>

          {/* 2 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              2. Hizmet Tanımı ve Kapsam
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Lezzet Yolda, kullanıcılar ile restoranlar arasında aracılık yapan bir platformdur.
              Platform; sipariş alma, ödeme işlemlerinin yürütülmesi ve teslimat koordinasyonu
              hizmetlerini sunar. Yemek üretimi restoranlar tarafından, teslimat ise kuryeler
              tarafından gerçekleştirilir. Platform, 6563 sayılı Elektronik Ticaretin
              Düzenlenmesi Hakkında Kanun ve 6502 sayılı Tüketicinin Korunması Hakkında Kanun
              kapsamında faaliyet göstermektedir.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Aracı Hizmet Sağlayıcı, Satıcı ile Alıcı arasındaki satış sözleşmesinin tarafı
              olmayıp yalnızca platformun kullanılmasını ve ödeme altyapısını sağlamaktadır.
              Ürünün hazırlanması, kalitesi, teslimatı ve satış sonrası hizmetlerden münhasıran
              Satıcı sorumludur.
            </p>
          </section>

          {/* 3 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              3. Üyelik ve Hesap Güvenliği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              3.1. Platformu kullanmak için üye olmanız gerekmektedir. Üyelik sırasında
              verdiğiniz bilgilerin doğru ve güncel olmasından siz sorumlusunuz.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              3.2. Üyelik için 18 yaşını doldurmuş olmanız gerekmektedir. 18 yaşından küçük
              bireyler platformu veli veya vasi gözetiminde kullanabilir.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              3.3. Hesap bilgilerinizin gizliliğinden ve güvenliğinden siz sorumlusunuz.
              Şifrenizi ve hesap bilgilerinizi üçüncü kişilerle paylaşmamalısınız.
            </p>
            <p className="text-gray-700 leading-relaxed">
              3.4. Hesap güvenliğinizin ihlal edildiğini fark etmeniz halinde derhal platformu
              bilgilendirmeniz gerekmektedir.
            </p>
          </section>

          {/* 4 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              4. Sipariş Süreci ve Ödeme
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              4.1. Siparişleriniz, restoran tarafından onaylandıktan sonra işleme alınır. Platform,
              siparişin restorana iletilmesinden ve teslimat koordinasyonundan sorumludur.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              4.2. Ödeme işlemleri güvenli ödeme altyapısı (PCI-DSS uyumlu) üzerinden
              gerçekleştirilir. Kredi kartı bilgileriniz tokenize edilerek saklanır; platform ham
              kart numarası depolamaz.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              4.3. Sipariş tutarı; ürün bedeli, teslimat ücreti, paketleme ücreti (varsa) ve KDV
              dahil toplam tutarı kapsar. Ödeme sayfasında tüm kalemler ayrıntılı gösterilir.
            </p>
            <p className="text-gray-700 leading-relaxed">
              4.4. Alıcı, platformda sözleşme konusu ürünün temel nitelikleri, satış fiyatı,
              ödeme şekli ve teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve
              elektronik ortamda gerekli teyidi verdiğini beyan eder.
            </p>
          </section>

          {/* 5 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              5. Teslimat Koşulları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              5.1. Siparişleriniz, platformda belirtilen tahmini teslimat süresi içerisinde
              Satıcı (restoran) tarafından hazırlanarak kurye aracılığıyla belirttiğiniz adrese
              teslim edilir. Teslimat süresi yasal 30 günlük süreyi aşmaz.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              5.2. Teslimat süreleri tahmini olarak belirtilir; hava koşulları, trafik yoğunluğu
              ve restoranın yoğunluğuna göre değişkenlik gösterebilir. Olası gecikmeler
              tarafınıza bildirilecektir.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              5.3. Teslimat adresinin doğruluğundan müşteri sorumludur. Yanlış veya eksik adres
              nedeniyle oluşan gecikme veya teslim edilememe durumunda platform sorumlu
              tutulamaz.
            </p>
            <p className="text-gray-700 leading-relaxed">
              5.4. Teslimat sırasında ürünleri kontrol etmeniz önerilir. Paket hasarlı veya
              eksik ise kurye nezaretinde durumu tespit ederek veya platforma derhal bildirim
              yapılması gerekmektedir.
            </p>
          </section>

          {/* 6 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              6. Cayma Hakkı
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Mesafeli Sözleşmeler Yönetmeliği&apos;nin 15. maddesi uyarınca, yiyecek ve içecek
              gibi çabuk bozulabilen veya son kullanma tarihi geçebilecek malların teslimine
              ilişkin sözleşmelerde cayma hakkı kullanılamaz.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Bu kapsamda, verilen yemek siparişlerinde siparişin Satıcı tarafından hazırlanmaya
              başlanmasından sonra cayma ve iade hakkı bulunmamaktadır. Hazırlanmamış siparişlerin
              iptali için aşağıdaki İptal ve İade Koşulları bölümü geçerlidir.
            </p>
          </section>

          {/* 7 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              7. İptal ve İade Koşulları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              7.1. Verdiğiniz siparişi, Satıcı (restoran) tarafından &quot;Hazırlanıyor&quot;
              durumuna geçirilmeden önce platform üzerinden iptal edebilirsiniz. İptal ücretsiz
              olarak işleme alınır.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              7.2. &quot;Hazırlanıyor&quot; veya &quot;Yolda&quot; statüsündeki siparişler için
              iptal işlemi yapılamamaktadır. Restoran hazırlığa başladıktan sonra yapılan iptal
              talepleri restoranın onayına tabidir.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              7.3. Teslim edilen ürünün siparişinizden farklı olması, eksik veya hasarlı olması
              durumunda, teslim anında kurye nezaretinde durumu tespit ederek veya derhal müşteri
              hizmetlerimizle iletişime geçerek iade veya telafi talebinde bulunabilirsiniz.
              Geçerli şikayetlerde Satıcı&apos;nın onayı ile ücret iadesi veya ürünün yeniden
              gönderimi sağlanacaktır.
            </p>
            <p className="text-gray-700 leading-relaxed">
              7.4. Ücret iadeleri, ödeme yönteminize bağlı olarak bankanızın süreçlerine göre
              1–10 iş günü içerisinde hesabınıza yansıtılacaktır.
            </p>
          </section>

          {/* 8 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              8. Kullanıcı Sorumlulukları ve Yasaklar
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Platformu kullanırken aşağıdaki davranışlar yasaktır:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
              <li>Yanıltıcı veya sahte bilgi vermek</li>
              <li>Başkalarının hesabını izinsiz kullanmak</li>
              <li>
                Platform, restoran veya kurye çalışanlarına tehdit veya hakaret içeren
                iletişimde bulunmak
              </li>
              <li>Platformun yazılım veya altyapısına müdahale etmek</li>
              <li>
                Üçüncü kişilerin platformu kullanmasını engelleyecek eylemlerde bulunmak
              </li>
              <li>Yasalara veya genel ahlak kurallarına aykırı içerik paylaşmak</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Bu kurallara aykırı davranış tespit edilmesi halinde hesabınız askıya alınabilir
              veya sonlandırılabilir; hukuki yollara başvurulabilir.
            </p>
          </section>

          {/* 9 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Fikri Mülkiyet</h2>
            <p className="text-gray-700 leading-relaxed">
              Platforma ait logo, marka, tasarım, yazılım ve içerikler{' '}
              {LEGAL_CONFIG.companyName}&apos;nin mülkiyetindedir. İzinsiz kopyalama, dağıtma
              veya ticari amaçla kullanım yasaktır.
            </p>
          </section>

          {/* 10 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              10. Sorumluluk Sınırlaması
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Platform, aracılık hizmeti sunmaktadır. Ürün kalitesi, gıda güvenliği ve restoran
              uygulamalarından restoranlar sorumludur. Teslimat sürecinden kurye hizmet
              sağlayıcıları sorumludur. Platform, bu tarafların kusurundan kaynaklanan
              zararlardan doğrudan sorumlu tutulamaz; ancak aracı olarak gerekli özeni
              göstermekle yükümlüdür.
            </p>
          </section>

          {/* 11 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              11. Kişisel Veriler ve Gizlilik
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Kişisel verileriniz 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK)
              kapsamında işlenmektedir. Detaylı bilgi için{' '}
              <Link to="/privacy" className="text-primary hover:underline font-medium">
                Gizlilik Politikası ve KVKK Aydınlatma Metnimizi
              </Link>{' '}
              inceleyebilirsiniz.
            </p>
          </section>

          {/* 12 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Değişiklik Hakkı</h2>
            <p className="text-gray-700 leading-relaxed">
              {LEGAL_CONFIG.companyName}, işbu Kullanım Koşullarını önceden haber vermeksizin
              değiştirme hakkını saklı tutar. Değişiklikler platform ve uygulama üzerinden
              duyurulacaktır. Değişikliklerden sonra platformu kullanmaya devam etmeniz, güncel
              koşulları kabul ettiğiniz anlamına gelir.
            </p>
          </section>

          {/* 13 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              13. Uygulanacak Hukuk ve Uyuşmazlık Çözümü
            </h2>
            <p className="text-gray-700 leading-relaxed">
              İşbu Koşullar Türkiye Cumhuriyeti kanunlarına tabidir. Tüketici işlemlerinden
              doğan uyuşmazlıklarda, T.C. Ticaret Bakanlığı&apos;nca ilan edilen değere kadar
              Tüketici Hakem Heyetleri, bu değeri aşan uyuşmazlıklarda ise Alıcı&apos;nın veya
              Satıcı&apos;nın yerleşim yerindeki Tüketici Mahkemeleri yetkilidir.
            </p>
          </section>

          {/* 14 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">14. İletişim</h2>
            <ul className="list-none pl-0 space-y-1 text-gray-700">
              <li>
                <strong>Unvan:</strong> {LEGAL_CONFIG.companyName}
              </li>
              <li>
                <strong>MERSİS No:</strong> {LEGAL_CONFIG.mersisNo}
              </li>
              <li>
                <strong>Adres:</strong> {LEGAL_CONFIG.fullAddress}
              </li>
              <li>
                <strong>E-posta:</strong>{' '}
                <a href={`mailto:${LEGAL_CONFIG.email}`} className="text-primary hover:underline">
                  {LEGAL_CONFIG.email}
                </a>
              </li>
            </ul>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
            <Link to="/privacy" className="text-primary hover:underline font-medium">
              Gizlilik Politikası
            </Link>
            <Link to="/cookies" className="text-primary hover:underline font-medium">
              Çerez Politikası
            </Link>
            <Link to="/" className="text-primary hover:underline font-medium">
              ← Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default TermsPage;
